<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="pannel">
    <div id="back"></div>
    <div class="background">
      <img
        src="https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/tableaudebord_v1.svg"
        style="max-width: 100%;"
      />
      <div class="button-bar">
        <img
          src="https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/support_bouton_v1.svg"
          style="max-width: 100%;"
        />
        <div ref="bruleur" class="bruleur" @click="move_bs_up"></div>
        <div ref="soupape" class="soupape" @click="move_bs_down"></div>
      </div>
      <div class="map-bar">
        <Map @newdir="rotateBoussole" v-bind:tutorial="tutorial" @talkie="reemitTalkie" />
      </div>
      <div ref="boussole" class="boussole">
        <img
          src="https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/boussole_v1.svg"
          style="max-width: 100%;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Map from "@/components/immersion03/jeu_ballon/map";
import Directions from "./direction";

export default {
  props: {
    tutorial: Boolean
  },
  components: { Map },
  methods: {
    reemitTalkie(event) {
      this.$emit("talkie", event);
    },
    move_bs_down() {
      this.$store.dispatch("changeMoveDirection", "down");
    },
    move_bs_up() {
      this.$store.dispatch("changeMoveDirection", "up");
    },
    rotateBoussole(new_dir) {
      this.$refs.boussole.classList.remove("boussole_north", "boussole_east", "boussole_west", "boussole_south");
      switch (new_dir) {
        case Directions.NORTH:
          this.$refs.boussole.classList.add("boussole_north");
          break;
        case Directions.EAST:
          this.$refs.boussole.classList.add("boussole_east");
          break;
        case Directions.SOUTH:
          this.$refs.boussole.classList.add("boussole_south");
          break;
        case Directions.WEST:
          this.$refs.boussole.classList.add("boussole_west");
          break;
      }
    },
    highlight(key) {
      if (key.code === "ArrowUp") {
        this.$refs.bruleur.classList.toggle("active");
        setTimeout(() => this.$refs.bruleur.classList.toggle("active"), 500);
      } else if (key.code === "ArrowDown") {
        this.$refs.soupape.classList.toggle("active");
        setTimeout(() => this.$refs.soupape.classList.toggle("active"), 500);
      }
    }
  }
};
</script>
<style>
#back {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  user-select: none;
}

.bruleur {
  position: absolute;
  height: 50%;
  width: 33%;
  left: 10%;
  bottom: 30%;
  background-image: url("https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/bouton_bruleur_off_v1.svg");
  background-repeat: no-repeat;
  transition: 0.3s;
  border-radius: 50%;
  z-index: 100;
  user-select: none;
}
.bruleur.active,
.bruleur:hover {
  background-image: url("https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/bouton_bruleur_on_v1.svg");
}
.soupape {
  position: absolute;
  height: 50%;
  width: 33%;
  left: 56%;
  bottom: 30%;
  background-image: url("https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/bouton_soupape_off_v1.svg");
  background-repeat: no-repeat;
  transition: 0.3s;
  border-radius: 50%;
  z-index: 100;
  user-select: none;
}
.soupape.active,
.soupape:hover {
  background-image: url("https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/bouton_soupape_on_v1.svg");
}
.button-bar {
  position: absolute;
  height: 70%;
  width: 30%;
  left: 10%;
  bottom: 10%;
  user-select: none;
}
.map-bar {
  position: absolute;
  height: 70%;
  width: 30%;
  left: 42%;
  bottom: 10%;
  user-select: none;
}
.boussole {
  position: absolute;
  width: 15%;
  right: 10%;
  bottom: 20%;
  transition: transform 1.3s ease;
  user-select: none;
}
.boussole_nord {
  transform: rotate(0deg);
}
.boussole_east {
  transform: rotate(270deg);
}
.boussole_west {
  transform: rotate(-270deg);
}
.boussole_south {
  transform: rotate(180deg);
}

.pannel {
  width: 100vw;
  z-index: 100;
  bottom: 0%;
  user-select: none;
}
.background {
  position: relative;
  padding: 0;
  width: 60vw;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  user-select: none;
}
</style>
